var _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYahoo = function SvgYahoo(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 247,
    viewBox: "0 0 285 247",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 60.1289H53.0681L83.969 139.067L115.271 60.1289H166.942L89.1372 247H37.1393L58.4369 197.482L0 60.1289Z",
    fill: "#5F01D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.147 199.194C196.902 199.194 211.295 184.823 211.295 167.095C211.295 149.368 196.902 134.997 179.147 134.997C161.393 134.997 147 149.368 147 167.095C147 184.823 161.393 199.194 179.147 199.194Z",
    fill: "#5F01D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.858 123.205H163.984L215.348 0H273.006L221.858 123.205Z",
    fill: "#5F01D1"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYahoo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yahoo.6c93364b.svg";
export { ForwardRef as ReactComponent };